import type { CrremPathwayScale } from "features/crrem-pathway-chart/model/types";

import { Stack } from "@mui/material";

import type { CrremSettings, EnergyAnalysisYearRange } from "../model/types";

import { EnergyAnalysisSettingsActions } from "./EnergyAnalysisSettingsActions";
import { EnergyAnalysisSettingsBadges } from "./EnergyAnalysisSettingsBadges";
import { EnergyAnalysisSnapshotYearSlider } from "./EnergyAnalysisSnapshotYearSlider";
import { EnergyAnalysisYearRangeSelect } from "./EnergyAnalysisYearRangeSelect";

type EnergyAnalysisSettingsProps = {
  disabled?: boolean;
  hideCorrectionSelection?: boolean;
  hideMetricSelection?: boolean;
  onSave: (settings: CrremSettings) => void;
  onScaleChange: (scale: CrremPathwayScale) => void;
  onSnapshotYearChange: (year: number) => void;
  onYearRangeChange: (yearRange: EnergyAnalysisYearRange) => void;
  scale: CrremPathwayScale;
  settings?: CrremSettings;
  snapshotYear?: number;
  snapshotYears: number[];
  yearRange?: EnergyAnalysisYearRange;
  years: number[];
};

export const EnergyAnalysisSettings = ({
  disabled,
  hideCorrectionSelection,
  hideMetricSelection,
  onSave,
  onScaleChange,
  onSnapshotYearChange,
  onYearRangeChange,
  scale,
  settings,
  snapshotYear,
  snapshotYears,
  yearRange,
  years,
}: EnergyAnalysisSettingsProps) => (
  <Stack className="w-full min-w-0 flex-wrap items-center gap-8">
    <EnergyAnalysisSettingsActions
      disabled={disabled}
      hideCorrectionSelection={hideCorrectionSelection}
      hideMetricSelection={hideMetricSelection}
      onSave={onSave}
      onScaleChange={onScaleChange}
      scale={scale}
      settings={settings}
    />
    <EnergyAnalysisSnapshotYearSlider
      disabled={disabled}
      onChange={onSnapshotYearChange}
      year={snapshotYear}
      years={snapshotYears}
    />
    <EnergyAnalysisYearRangeSelect
      disabled={disabled}
      onChange={onYearRangeChange}
      yearRange={yearRange}
      years={years}
    />
    {settings ? (
      <EnergyAnalysisSettingsBadges
        hideCorrections={hideCorrectionSelection}
        hideMetric={hideMetricSelection}
        scale={scale}
        settings={settings}
      />
    ) : null}
  </Stack>
);
